<template>
  <div v-if="!sick">
    <div class="card mb-4">
      <div class="card-header">
        <h2>Arbeidsongeschikt melden</h2>
      </div>
      <!-- tax upload commented out -->
      <!--<div v-if="noTax && shouldHaveTax" class="card-body">
        <belasting-uploaden :should-have-tax="shouldHaveTax" v-bind:no-tax="noTax" v-on:update-no-tax="noTax = $event"></belasting-uploaden>
      </div>
      <div v-else class="card-body">
        <p>Je kan aangeven dat je arbeidsongeschikt bent via onderstaande knop.</p>
        <a href="/dashboard/afmelden" class="btn btn-primary">Ik ben arbeidsongeschikt</a>
      </div>-->
      <div class="card-body">
        <p>Je kan aangeven dat je arbeidsongeschikt bent via onderstaande knop.</p>
        <a href="/dashboard/afmelden" class="btn btn-primary">Ik ben arbeidsongeschikt</a>
      </div>
    </div>
  </div>
</template>

<script>
import BelastingUploaden from './BelastingUploaden';
import mustBeTrue from '../js/validators/mustBeTrue';

export default {
    components: {
        BelastingUploaden
    },
    props: {
        route: String,
        sickProp: Boolean,
        noTaxProp: Boolean,
        shouldHaveTaxProp: Boolean,
    },
    data() {
        return {
            sick: this.sickProp,
            noTax: this.noTaxProp,
            shouldHaveTax: this.shouldHaveTaxProp,
        };
    },
    validations() {
        return {
            checkboxInfo: {
                mustBeTrue,
            },
            checkboxDoctor: {
                mustBeTrue,
            },
        };
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/ZiekMelden.vue